import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import { getAirportRoutes, getRouteIcon } from "./functions";
import Lotnisko from "../Lotnisko";
import Glyphicon from "../Glyphicon";

class InfoWindowNajczestszeTrasy extends PureComponent<any> {
  static contextType = AppContext;

  render() {
    const { id } = this.props;
    const { airports, routes } = this.context;
    const airportRoutes = getAirportRoutes(id, airports, routes);
    if (airportRoutes.length === 0) return null;
    return (
      <section className="InfoWindowNajczestszeTrasy">
        Trasy:
        <ul className="InfoWindowNajczestszeTrasy_list">
          {airportRoutes.map((route: any) => (
            <li key={route.dep + "-" + route.arr}>
              <Glyphicon
                className="InfoWindowNajczestszeTrasy_icon"
                icon={getRouteIcon(id, route)}
              />
              <Lotnisko id={route.dep} /> - <Lotnisko id={route.arr} /> (
              {route.pastFlights})
            </li>
          ))}
        </ul>
      </section>
    );
  }
}

export default InfoWindowNajczestszeTrasy;
